import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

import Search from "./Search"
import SearchBarGeneric from "./searchBarGeneric"
import MergeSurvey from "./MergeSurvey";

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
    SG_GET_DEBRIEF_SCHEDULES,
    SG_GET_SURVEY_QUESTION_SELECT,
    DEBRIEF_SCHEDULE_PAGE_NUMBER,
    CLEAR_ERRORS,
    DEBRIEF_SCHEDULE_SEARCH_TERM
} from "constants/actions";

// shadcn/ui components
import { Card, CardContent } from "components/ui/card";
import { Alert, AlertDescription } from "components/ui/alert";
import { Skeleton } from "components/ui/skeleton";
import { Button } from "components/ui/button";
import { Badge } from "components/ui/badge";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "components/ui/table";
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "components/ui/pagination";

// Lucide icons
import { AlertCircle, CheckCircle2, Loader2, Inbox, ArrowRight, Calendar } from "lucide-react";

import OrganizationSelect from "organizations/OrganizationSelect";


const List = ({ hideOrgSelect }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [organizationId, setOrganizationId] = useState(false)
    const [resetPageLoad, setResetPageLoad] = useState(false)

    const [results, setResults] = useState([]);
    const [page, setPage] = React.useState(1);
    const [loading, setLoading] = useState(false)
    const [totalPages, setTotalPages] = useState(1)
    const [mergeSurveyError, setMergeSurveyError] = useState()
    const [mergeSurvey, setMergeSurvey] = useState({
        org: null,
        name: null,
        original_brief: null,
        merge_brief: null
    })

    const [startDate, setStartDate] = useState(new Date());
    var someDate = new Date();
    var result = someDate.setDate(someDate.getDate() + 7);
    const [endDate, setEndDate] = useState(new Date(result));
    const [searchFor, setSearchFor] = useState(false);
    const [searchTerm, setSearchTerm] = useState(false)

    useEffect(() => {
        dispatch({
            type: SG_GET_SURVEY_QUESTION_SELECT,
        });
    }, [dispatch]);

    useEffect(() => {
        // if the response is ok 200
        const _from = startDate.toISOString()
        const _to = endDate.toISOString()
        if (searchFor) {
            dispatch({
                type: SG_GET_DEBRIEF_SCHEDULES,
                payload: `page=${page}${searchFor ? `&${searchFor}=true&from=${_from}&to=${_to}` : ''}${organizationId ? `&organization=${organizationId}` : ''}`,
            });
        } else if (searchTerm) {
            dispatch({
                type: DEBRIEF_SCHEDULE_SEARCH_TERM,
                payload: searchTerm,
            })
            dispatch({
                type: SG_GET_DEBRIEF_SCHEDULES,
                payload: `page=${page}&survey_token=${searchTerm}`,
            });
        } else {
            dispatch({
                type: SG_GET_DEBRIEF_SCHEDULES,
                payload: `page=${page}${organizationId ? `&organization=${organizationId}` : ''}`,
            });
        }
        dispatch({type: CLEAR_ERRORS})
        setLoading(true)
    }, [dispatch, page, organizationId, searchFor, startDate, endDate, searchTerm]);


    const { 
        get_error,
        get_brief_schedules,
        get_merge_debriefs,
        get_selectedOrg,
        get_organization_select,
        get_survey_question_select
    } = useSelector(
        (state) => ({
            get_error: state.errors,
            get_brief_schedules: state.debrief_schedule,
            get_merge_debriefs: state.debrief_schedule.merge_debrief,
            get_selectedOrg: state.selectedOrg,
            get_organization_select: state.organizations.organization_select,
            get_survey_question_select: state.surveyquestion.survey_question_select,
        }),
        shallowEqual
    );

    useEffect(() => {
        setOrganizationId(get_selectedOrg?.organization?.id)
        // setResetPageLoad(!resetPageLoad)
    }, [get_selectedOrg]);


    useEffect(() => {
        setResults(get_brief_schedules?.debrief_schedule?.results);
        setPage(get_brief_schedules?.pageNumber)
        setTotalPages(Math.ceil(get_brief_schedules?.debrief_schedule?.count / get_brief_schedules?.debrief_schedule?.page_size))
        if (get_brief_schedules?.debrief_schedule?.count % get_brief_schedules?.debrief_schedule?.page_size) {
            setTotalPages(Math.ceil(get_brief_schedules?.debrief_schedule?.count / get_brief_schedules?.debrief_schedule?.page_size))
        }
        if (get_brief_schedules?.search) {
            setStartDate(get_brief_schedules?.search?.from)
            setEndDate(get_brief_schedules?.search?.to)
            setSearchFor(get_brief_schedules?.search?.search_for)
        }
    }, [get_brief_schedules, page]);



    useEffect(() => {
        // 
        const timer1 = setTimeout(() => {
            setLoading(false)
        }, 2000);
        return () => clearTimeout(timer1);
    }, [loading]);

    useEffect(() => {
        setMergeSurveyError(get_merge_debriefs.message)
    }, [get_merge_debriefs.message]);

    function reloadPage() {
        setMergeSurveyError(false)
        setPage(1)
        setMergeSurvey({
            org: null,
            name: null,
            original_brief: null,
            merge_brief: null
        })
    }

    const handlePageChange = (newPage) => {
        setPage(newPage);
        dispatch({
            type: DEBRIEF_SCHEDULE_PAGE_NUMBER,
            payload: newPage,
        });
        // Scroll to top of results
        const resultsElement = document.getElementById("results");
        if (resultsElement) {
            resultsElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const renderPaginationItems = () => {
        const items = [];
        const currentPage = page || 1;
        const total = totalPages || 1;
        
        const handleClick = (e, pageNum) => {
            e.preventDefault();
            handlePageChange(pageNum);
        };
        
        // Show first page
        if (currentPage > 3) {
            items.push(
                <PaginationItem key={1}>
                    <PaginationLink 
                        onClick={(e) => handleClick(e, 1)}
                        className="cursor-pointer"
                    >
                        1
                    </PaginationLink>
                </PaginationItem>
            );
            if (currentPage > 4) {
                items.push(
                    <PaginationItem key="ellipsis1">
                        <PaginationEllipsis />
                    </PaginationItem>
                );
            }
        }

        // Show pages around current page
        const start = Math.max(1, currentPage - 2);
        const end = Math.min(total, currentPage + 2);
        
        for (let i = start; i <= end; i++) {
            items.push(
                <PaginationItem key={i}>
                    <PaginationLink
                        onClick={(e) => handleClick(e, i)}
                        isActive={i === currentPage}
                        className="cursor-pointer"
                    >
                        {i}
                    </PaginationLink>
                </PaginationItem>
            );
        }

        // Show last page
        if (currentPage < total - 2) {
            if (currentPage < total - 3) {
                items.push(
                    <PaginationItem key="ellipsis2">
                        <PaginationEllipsis />
                    </PaginationItem>
                );
            }
            items.push(
                <PaginationItem key={total}>
                    <PaginationLink 
                        onClick={(e) => handleClick(e, total)}
                        className="cursor-pointer"
                    >
                        {total}
                    </PaginationLink>
                </PaginationItem>
            );
        }

        return items;
    };

    return (
        <div className="min-h-screen bg-background">
            <div className="container mx-auto px-4 py-6 md:px-6 lg:px-8 lg:py-8">
                {/* Organization Select */}
                {!hideOrgSelect && (
                    <div className="mb-6">
                        <OrganizationSelect setResetPageLoad={setResetPageLoad} />
                    </div>
                )}

                {/* Alert Messages */}
                {mergeSurveyError?.message && (
                    <Alert
                        variant={mergeSurveyError?.error ? "destructive" : "default"}
                        className="mb-6"
                    >
                        {mergeSurveyError?.error ? (
                            <AlertCircle className="h-4 w-4" />
                        ) : (
                            <CheckCircle2 className="h-4 w-4" />
                        )}
                        <AlertDescription className="flex items-center justify-between">
                            <span>{mergeSurveyError?.message}</span>
                            <button
                                onClick={reloadPage}
                                className="ml-4 text-sm underline hover:no-underline"
                            >
                                Dismiss
                            </button>
                        </AlertDescription>
                    </Alert>
                )}

                {/* Search Section */}
                <div className="mb-6">
                    <Search
                        organizationId={organizationId}
                        loading={loading}
                        setLoading={setLoading}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        searchFor={searchFor}
                        setSearchFor={setSearchFor}
                    />
                </div>

                {/* Search Bar Generic */}
                <div className="mb-6">
                    <SearchBarGeneric
                        label="Employee survey token"
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        error={get_error?.errors?.data?.detail}
                    />
                </div>

                {/* Results Section */}
                <div id="results" className="relative">
                    {loading && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/80 backdrop-blur-sm rounded-lg">
                            <div className="flex flex-col items-center gap-2">
                                <Loader2 className="h-8 w-8 animate-spin text-primary" />
                                <p className="text-sm text-muted-foreground">Loading schedules...</p>
                            </div>
                        </div>
                    )}

                    {!loading && results && results.length === 0 && (
                        <Card className="border-dashed">
                            <CardContent className="flex flex-col items-center justify-center py-16">
                                <Inbox className="h-12 w-12 text-muted-foreground mb-4" />
                                <h3 className="text-lg font-semibold mb-2">No schedules found</h3>
                                <p className="text-sm text-muted-foreground text-center max-w-md">
                                    {searchTerm || searchFor
                                        ? "Try adjusting your search criteria to find more results."
                                        : "There are no scheduled briefs at the moment."}
                                </p>
                            </CardContent>
                        </Card>
                    )}

                    {!loading && results && results.length > 0 && (
                        <Card>
                            <div className="rounded-md border">
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead>Organization Name</TableHead>
                                            <TableHead>Status</TableHead>
                                            <TableHead className="text-right">Employees</TableHead>
                                            <TableHead className="text-right">Responded</TableHead>
                                            <TableHead>Scheduled Date</TableHead>
                                            <TableHead>Close Date</TableHead>
                                            <TableHead className="text-right">Actions</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {results.map((result) => {
                                            const organizationName = result?.organization &&
                                                get_organization_select?.filter(
                                                    (org) => org.id === result?.organization
                                                )?.[0]?.name;

                                            const getStatusBadgeVariant = (status) => {
                                                if (status < 3) return "secondary";
                                                if (status < 11) return "default";
                                                if (status === 21) return "outline";
                                                return "secondary";
                                            };

                                            const getStatusColor = (status) => {
                                                if (status < 3) return "bg-orange-500";
                                                if (status < 11) return "bg-green-500";
                                                if (status === 21) return "bg-violet-500";
                                                return "bg-gray-500";
                                            };

                                            return (
                                                <TableRow key={result?.id}>
                                                    <TableCell className="font-medium">
                                                        {result?.organization} #{organizationName || "N/A"}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Badge 
                                                            variant={getStatusBadgeVariant(result?.status)}
                                                            className={getStatusColor(result?.status)}
                                                        >
                                                            {result?.status_text || "N/A"}
                                                        </Badge>
                                                    </TableCell>
                                                    <TableCell className="text-right">
                                                        {result?.total_requests || 0}
                                                    </TableCell>
                                                    <TableCell className="text-right">
                                                        {result?.total_responses || 0}
                                                    </TableCell>
                                                    <TableCell>
                                                        {result?.scheduled_for ? (
                                                            <div className="flex items-center gap-2">
                                                                <Calendar className="h-4 w-4 text-muted-foreground" />
                                                                <span>
                                                                    {format(new Date(result?.scheduled_for), "dd-MMM-yyyy hh:mm a")}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {result?.close_at ? (
                                                            <div className="flex items-center gap-2">
                                                                <Calendar className="h-4 w-4 text-muted-foreground" />
                                                                <span>
                                                                    {format(new Date(result?.close_at), "dd-MMM-yyyy hh:mm a")}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </TableCell>
                                                    <TableCell className="text-right">
                                                        <div className="flex items-center justify-end gap-2">
                                                            <MergeSurvey
                                                                debriefSchedule={result}
                                                                setMergeSurvey={setMergeSurvey}
                                                                mergeSurvey={mergeSurvey}
                                                            />
                                                            <Button
                                                                variant="outline"
                                                                size="sm"
                                                                onClick={() => navigate(`/app/brief-schedule/details/${result?.id}`)}
                                                                className="gap-2"
                                                            >
                                                                Details
                                                                <ArrowRight className="h-4 w-4" />
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </Card>
                    )}

                    {/* Loading Skeletons */}
                    {loading && results && results.length === 0 && (
                        <Card>
                            <div className="rounded-md border">
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead>Organization Name</TableHead>
                                            <TableHead>Status</TableHead>
                                            <TableHead className="text-right">Employees</TableHead>
                                            <TableHead className="text-right">Responded</TableHead>
                                            <TableHead>Scheduled Date</TableHead>
                                            <TableHead>Close Date</TableHead>
                                            <TableHead className="text-right">Actions</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {[...Array(5)].map((_, i) => (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    <Skeleton className="h-4 w-32" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton className="h-5 w-20" />
                                                </TableCell>
                                                <TableCell className="text-right">
                                                    <Skeleton className="h-4 w-12 ml-auto" />
                                                </TableCell>
                                                <TableCell className="text-right">
                                                    <Skeleton className="h-4 w-12 ml-auto" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton className="h-4 w-32" />
                                                </TableCell>
                                                <TableCell>
                                                    <Skeleton className="h-4 w-32" />
                                                </TableCell>
                                                <TableCell className="text-right">
                                                    <div className="flex items-center justify-end gap-2">
                                                        <Skeleton className="h-8 w-16" />
                                                        <Skeleton className="h-8 w-20" />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Card>
                    )}
                </div>

                {/* Pagination */}
                {!loading && results && results.length > 0 && totalPages > 1 && (
                    <div className="mt-8 flex justify-center">
                        <Pagination>
                            <PaginationContent>
                                <PaginationItem>
                                    <PaginationPrevious
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if ((page || 1) > 1) {
                                                handlePageChange((page || 1) - 1);
                                            }
                                        }}
                                        className={
                                            (page || 1) === 1
                                                ? "pointer-events-none opacity-50"
                                                : "cursor-pointer"
                                        }
                                    />
                                </PaginationItem>
                                {renderPaginationItems()}
                                <PaginationItem>
                                    <PaginationNext
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if ((page || 1) < (totalPages || 1)) {
                                                handlePageChange((page || 1) + 1);
                                            }
                                        }}
                                        className={
                                            (page || 1) >= (totalPages || 1)
                                                ? "pointer-events-none opacity-50"
                                                : "cursor-pointer"
                                        }
                                    />
                                </PaginationItem>
                            </PaginationContent>
                        </Pagination>
                    </div>
                )}

                {/* Results Count */}
                {!loading && results && results.length > 0 && (
                    <div className="mt-6 text-center text-sm text-muted-foreground">
                        Showing {results.length} of {get_brief_schedules?.debrief_schedule?.count || 0} results
                        {totalPages > 1 && ` (Page ${page || 1} of ${totalPages})`}
                    </div>
                )}
            </div>
        </div>
    );
};

export default List;